<template>
  <div class="project-register-list">
    <Spin v-if="loading"></Spin>
    <list-zheng-zhou-ren-she v-else-if="mode==='ZhengZhouRenShe'" />
    <list-jiao-zuo-ren-she v-else-if="mode==='JiaoZuoRenShe'" />
    <list-hai-nan-ren-she v-else-if="mode==='HaiNanRenShe'" />
    <Alert type="error" show-icon v-else>
      啊偶！出错了
      <span slot="desc">
        您没有访问当前页面的权限
      </span>
    </Alert>
  </div>
</template>

<script>
import ListZhengZhouRenShe from './ZhengZhouRenShe/List.vue'
import ListJiaoZuoRenShe from './JiaoZuoRenShe/List.vue'
import ListHaiNanRenShe from './HaiNanRenShe/List.vue'
export default {
  name: 'project-register-list',
  props: {
  },
  components: {
    ListZhengZhouRenShe,
    ListJiaoZuoRenShe,
    ListHaiNanRenShe
  },
  data () {
    return {
      loading: false,
      supvPerms: {
        canAuditGuarantor: false,
        canPreAuditGuarantor: false,
        canBlacklistGuarantor: false,
        canClaim: false,
        canAddProjectRegister: false,
        canAuditProjectRegister: false,
        projectRegisterMode: null
      },
      mode: ''
    }
  },
  watch: {
  },
  async mounted () {
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode
    }
    await this.getMySupervisionPermission()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    async getMySupervisionPermission () {
      this.loading = true
      await this.$Api.Supervisor.getMySupervisorPermissions()
      .then((res) => {
        // console.log(res)
        this.supvPerms = res
        this.mode = res.projectRegisterMode
        this.loading = false
        return Promise.resolve()
      })
      .catch((err) => {
        this.loading = false
        this.supvPerms = {
          canAuditGuarantor: false,
          canPreAuditGuarantor: false,
          canBlacklistGuarantor: false,
          canClaim: false,
          canAddProjectRegister: false,
          canAuditProjectRegister: false,
          projectRegisterMode: null
        }
        return Promise.reject(err)
      })
    },
  }
}
</script>

<style lang="less" scoped>
</style>
